export default "__VITE_ASSET__D90T5Tz2__"